var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPluvaShop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pluva_shop 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.6666 13.6685L20 8.39104L8.33331 13.6685V32.696C8.33331 33.2327 8.76915 33.6685 9.30581 33.6685H15.1391C15.6758 33.6685 16.1116 33.2327 16.1116 32.696V24.6402C16.1116 24.1035 16.5475 23.6677 17.0841 23.6677H22.9175C23.4541 23.6677 23.89 24.1035 23.89 24.6402V32.696C23.89 33.2327 24.3258 33.6685 24.8625 33.6685H30.6958C31.2308 33.6685 31.6666 33.2327 31.6666 32.696V13.6685Z",
    fill: "#C6C6D5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.3333 7.00187V18.2952C13.4767 18.2952 13.6208 18.3677 13.695 18.5127C14.2458 19.5944 15.37 20.3352 16.6667 20.3352C17.9633 20.3352 19.0875 19.5944 19.6383 18.5127C19.7125 18.3677 19.8558 18.2952 20 18.2952V7.00187H13.3333Z",
    fill: "#697DFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.07169 7.00187C8.18919 7.00187 7.45919 7.68937 7.40752 8.57104L6.66669 17.0019C6.66669 18.8427 8.15919 20.3352 10 20.3352C11.2967 20.3352 12.4209 19.5944 12.9717 18.5127C13.0459 18.3677 13.1892 18.2952 13.3334 18.2952V7.00187H9.07169Z",
    fill: "#445EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.5925 8.57104C32.5409 7.68937 31.8109 7.00187 30.9284 7.00187H26.6667V18.2952C26.81 18.2952 26.9542 18.3677 27.0284 18.5127C27.5792 19.5944 28.7034 20.3352 30 20.3352C31.8409 20.3352 33.3334 18.8427 33.3334 17.0019L32.5925 8.57104Z",
    fill: "#697DFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20 7.00187V18.2952C20.1434 18.2952 20.2875 18.3677 20.3617 18.5127C20.9125 19.5944 22.0367 20.3352 23.3334 20.3352C24.63 20.3352 25.7542 19.5944 26.305 18.5127C26.3792 18.3677 26.5225 18.2952 26.6667 18.2952V7.00187H20Z",
    fill: "#445EFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluvaShop);
export default __webpack_public_path__ + "static/media/pluva-shop.efd334e1a342242ef2f41fb31b3ceece.svg";
export { ForwardRef as ReactComponent };